import React from "react";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import { MARKETPLACE_SUMMARY_PAGES } from './constants';
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import withShipment from "../../../withShipment";
import {
    lastUpdatedDateProvinceSummarySelector,
    lastUpdatedDateSummarySelector,
    loadingSelector, marketplaceProvinceSummarySelector, marketplaceSummaryProgressSelector,
    marketplaceSummarySelector, marketplaceSummarySessionIdSelector,
    shippingSettingSelector,
} from '../../../redux/selectors/accounting';
import {statusSelector} from "../../../redux/selectors/global";
import {clearStatus} from "../../../redux/actions/global";
import {userInfoSelector} from "../../../redux/selectors/auth";
import {getTableSetting, saveTableSetting} from "../../../redux/actions/account";
import MarketplaceSummaryTable from './MarketplaceTable';
import {
    importMarketplaceSummary, listMarketplaceProvinceSummary,
    listMarketplaceSummary, previewMarketplaceSummary,
    listShippingSettings, marketplaceProgressSummary,
    listImportedFiles, getImportedFileRows, renameImportedFile, deleteImportedFile,
    listImportLogs, deleteImportLog, clearImportLogs,
} from '../../../redux/actions/accounting';
import { tableSettingSelector } from '../../../redux/selectors/account';
import ProvinceSummaryTable from './ProvinceSummaryTable';
import ImportedFiles from './ImportedFiles';
import MarketplaceAuditPreviewDialog from './preview/MarketplaceAuditPreviewDialog';
import { buildMarketplaceDiff } from './preview/marketplaceDiff';

class MarketplaceSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: MARKETPLACE_SUMMARY_PAGES.TABLE,
      feedbackBarOpen: false,
      selectedYear: new Date().getFullYear(),
      selectedQuarters: null,
      selectedCurrency: 'Consolidated',
      selectedMonth: '',
      marketplaceSummaryFilterSetting: null,
      customFeedbackBarOpen: false,
      customMessage: '',
      customStatus: 'error',
      isRefresh: false,
      isAuditPreviewOpen: false,
      previewRows: null,
      previewOldRows: null,
    };
  }

  async componentDidMount() {
    this.props.getTableSetting(this.props.user.userId);
    this.props.listShippingSettings();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }

    if (prevProps.tableSetting !== this.props.tableSetting) {
      const savedSetting =
        this.props.tableSetting?.marketplaceSummaryFilterSetting || {};

      const current = this.state.marketplaceSummaryFilterSetting || {};

      const {
        currency = current.currency || 'Consolidated',
        year = current.year || new Date().getFullYear(),
        month = current.month || '',
        quarters = current.quarters || '',
      } = savedSetting;

      const mergedSetting = {
        currency,
        year,
        month,
        quarters,
      };

      this.setState(
        {
          marketplaceSummaryFilterSetting: mergedSetting,
          selectedCurrency: currency,
          selectedYear: year,
          selectedMonth: month,
          selectedQuarters: quarters,
        },
        () => {
          this.listMarketplaceAPI(false);
        }
      );
    }
  }

  handleYearChange = (event) => {
    const value = event.target.value;
    this.setState({ selectedYear: value }, () => {
      this.onFiltersInputChange('year', value);
    });
  };

  handleMonthChange = (event) => {
    const value = event.target.value;
    this.setState({ selectedMonth: value }, () => {
      this.onFiltersInputChange('month', value);
    });
  };

  handleCurrencyChange = (event) => {
    const value = event.target.value;
    this.setState({ selectedCurrency: value }, () => {
      this.onFiltersInputChange('currency', value);
    });
  };

  handleQuarterChange = (quarter) => {
    const quarterMapping = {
      'QTR 1': 1,
      'QTR 2': 2,
      'QTR 3': 3,
      'QTR 4': 4,
    };
    const quarterNumber = quarterMapping[quarter];
    const selectedQuarters =
      this.state.selectedQuarters === quarterNumber ? null : quarterNumber;
    this.setState({ selectedQuarters, selectedMonth: '' }, () => {
      this.onFiltersInputChange('quarters', selectedQuarters);
    });
  };

  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  onFiltersInputChange = (name, value) => {
    let filtersMap = {
      ...(this.props.tableSetting?.marketplaceSummaryFilterSetting || {}),
    };

    if (name === 'quarters') {
      filtersMap[name] = value;
      // Clear month when a quarter is selected
      filtersMap['month'] = '';
    } else if (name === 'multiple') {
      Object.assign(filtersMap, value);
    } else {
      filtersMap[name] = value;

      if (name === 'month' && value) {
        filtersMap['quarters'] = '';
      }
    }

    this.saveUpdatedFilters(filtersMap);
  };

  saveUpdatedFilters = (filters) => {
    this.props.saveTableSetting({
      userId: this.props.user.userId,
      tableSetting: null,
      changeFilters: false,
      changeMarketplaceSummaryFilters: true,
      marketplaceSummaryFilters: filters,
    });
  };

  displayTable = () => {
    return (
      <MarketplaceSummaryTable
        loadingData={this.props.loadingData}
        setCurrentPage={this.setCurrentPage}
        customFeedBackBar={this.customFeedBackBar}
        openFeedbackBar={this.openFeedbackBar}
        marketplaceSummary={this.props.marketplaceSummary}
        importMarketplaceSummary={this.props.importMarketplaceSummary}
        listMarketplaceSummary={this.props.listMarketplaceSummary}
        selectedQuarters={this.state.selectedQuarters}
        selectedYear={this.state.selectedYear}
        handleQuarterChange={this.handleQuarterChange}
        handleYearChange={this.handleYearChange}
        selectedCurrency={this.state.selectedCurrency}
        handleCurrencyChange={this.handleCurrencyChange}
        selectedMonth={this.state.selectedMonth}
        handleMonthChange={this.handleMonthChange}
        listMarketplaceAPI={this.listMarketplaceAPI}
        progress={this.props.progress}
        sessionId={this.props.sessionId}
        setFetch={this.setFetch}
        onRefresh={this.handleOpenAuditPreview}
        marketplaceProgressSummary={this.props.marketplaceProgressSummary}
        lastUpdatedAt={this.props.lastUpdatedAt}
        listImportLogs={this.props.listImportLogs}
        deleteImportLog={this.props.deleteImportLog}
        clearImportLogs={this.props.clearImportLogs}
      />
    );
  };

  importedFilesView = () => {
    return (
      <ImportedFiles
        setCurrentPage={this.setCurrentPage}
        customFeedBackBar={this.customFeedBackBar}
        listImportedFiles={this.props.listImportedFiles}
        getImportedFileRows={this.props.getImportedFileRows}
        renameImportedFile={this.props.renameImportedFile}
        deleteImportedFile={this.props.deleteImportedFile}
        onImportedFilesChanged={() => this.listMarketplaceAPI(true)}
      />
    );
  };

  provinceTable = () => {
    return (
      <ProvinceSummaryTable
        loadingData={this.props.loadingData}
        setCurrentPage={this.setCurrentPage}
        customFeedBackBar={this.customFeedBackBar}
        openFeedbackBar={this.openFeedbackBar}
        marketplaceProvinceSummary={this.props.marketplaceProvinceSummary}
        listMarketplaceProvinceSummary={
          this.props.listMarketplaceProvinceSummary
        }
        saveTableSetting={this.props.saveTableSetting}
        tableMarketplaceSetting={this.props.tableSetting}
        user={this.props.user}
        getTableSetting={this.props.getTableSetting}
        provinceLastUpdatedAt={this.props.provinceLastUpdatedAt}
      />
    );
  };

  setFetch = (bool) => {
    this.setState({ isRefresh: bool }, () => {
      this.listMarketplaceAPI(bool);
    });
  };

  // Shared filter payload used by both the list and the preview recompute.
  buildMarketplaceQuery = () => {
    const {
      selectedYear,
      selectedQuarters,
      selectedMonth = '',
      selectedCurrency,
    } = this.state;

    return {
      year: selectedYear || new Date().getFullYear(),
      quarter: selectedQuarters ? [selectedQuarters] : [1, 2, 3, 4],
      month: (selectedMonth || '').toString().trim(),
      currency: selectedCurrency,
    };
  };

  // Refresh entry point: capture the currently displayed rows as the "before" baseline, then
  // fetch a non-persisting recompute and open the audit preview. Nothing is committed until apply.
  handleOpenAuditPreview = () => {
    const oldRows = Array.isArray(this.props.marketplaceSummary)
      ? [...this.props.marketplaceSummary]
      : [];

    this.setState({
      isAuditPreviewOpen: true,
      previewRows: null,
      previewOldRows: oldRows,
    });

    this.props.previewMarketplaceSummary(this.buildMarketplaceQuery(), (error, response) => {
      if (response && response.marketplaceSummary) {
        this.setState({ previewRows: response.marketplaceSummary });
      } else {
        this.setState({ isAuditPreviewOpen: false, previewOldRows: null });
      }
    });
  };

  // Apply = run the real (persisting) refresh, which recomputes, saves the cache and repaints.
  handleApplyPreview = () => {
    this.setState(
      { isAuditPreviewOpen: false, previewRows: null, previewOldRows: null },
      () => {
        this.setFetch(true);
      }
    );
  };

  handleRejectPreview = () => {
    this.setState({ isAuditPreviewOpen: false, previewRows: null, previewOldRows: null });
  };

  buildPreviewData = () => {
    const previewLoading = this.state.isAuditPreviewOpen && !this.state.previewRows;
    const diff = (this.state.isAuditPreviewOpen && this.state.previewRows)
      ? buildMarketplaceDiff(
          this.state.selectedCurrency,
          this.state.previewOldRows || [],
          this.state.previewRows
        )
      : null;
    return { previewLoading, diff };
  };

  listMarketplaceAPI = (isRefresh) => {
    const {
      selectedYear,
      selectedQuarters,
      selectedMonth = '',
      selectedCurrency,
    } = this.state;

    const safeMonth = (selectedMonth || '').toString().trim();

    const data = {
      year: selectedYear || new Date().getFullYear(),
      quarter: selectedQuarters ? [selectedQuarters] : [1, 2, 3, 4],
      month: safeMonth,
      currency: selectedCurrency,
      isRefresh: isRefresh,
    };

    this.props.listMarketplaceSummary(data);
  };

  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case MARKETPLACE_SUMMARY_PAGES.TABLE:
        return this.displayTable();
      case MARKETPLACE_SUMMARY_PAGES.PROVINCE_SUMMARY:
        return this.provinceTable();
      case MARKETPLACE_SUMMARY_PAGES.IMPORTED_FILES:
        return this.importedFilesView();
      default:
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  customFeedBackBar = (status, message) => {
    this.setState({
      customFeedbackBarOpen: true,
      customStatus: status,
      customMessage: message,
    });
  };

  customCloseFeedbackBar = () => {
    this.setState({ customFeedbackBarOpen: false }, () => {
      this.setState({ customStatus: '', customMessage: '' });
    });
  };

  openFeedbackBar = () => {
    this.setState({ feedbackBarOpen: true });
  };

  closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false }, () => {
      this.props.clearStatus();
    });
  };

  render() {
    const { previewLoading, diff } = this.buildPreviewData();

    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <MarketplaceAuditPreviewDialog
          open={this.state.isAuditPreviewOpen}
          loading={previewLoading}
          diff={diff}
          onApply={this.handleApplyPreview}
          onCancel={this.handleRejectPreview}
        />
        <FeedbackBar
          open={this.state.customFeedbackBarOpen}
          handleClose={this.customCloseFeedbackBar}
          severity={this.state.customStatus === 'error' ? 'error' : 'success'}
          message={this.state.customMessage}
        />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.props.status?.success ? 'success' : 'error'}
          message={this.props.status?.statusText}
        />
        {this.displayCurrentPage()}
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => ({
    status: statusSelector(state),
    user: userInfoSelector(state),
    loadingData: loadingSelector(state),
    marketplaceSummary: marketplaceSummarySelector(state),
    shippingSettings: shippingSettingSelector(state),
    tableSetting: tableSettingSelector(state),
    progress: marketplaceSummaryProgressSelector(state),
    sessionId: marketplaceSummarySessionIdSelector(state),
    lastUpdatedAt: lastUpdatedDateSummarySelector(state),
    provinceLastUpdatedAt : lastUpdatedDateProvinceSummarySelector(state),
    marketplaceProvinceSummary: marketplaceProvinceSummarySelector(state),
})


const actionCreators = {
    clearStatus,
    saveTableSetting,
    getTableSetting,
    importMarketplaceSummary,
    listMarketplaceSummary,
    previewMarketplaceSummary,
    listShippingSettings,
    marketplaceProgressSummary,
    listMarketplaceProvinceSummary,
    listImportedFiles,
    getImportedFileRows,
    renameImportedFile,
    deleteImportedFile,
    listImportLogs,
    deleteImportLog,
    clearImportLogs
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, MarketplaceSummary);